import { useVersionUpdateKind } from 'modules/shares/operations'
import { useToast } from 'containers/ToastManager'
import { useModalContext } from 'containers/ModalManager'
import { StarUpdateModal } from 'modules/shares/components/StarUpdateModal'

export interface UseVersionStarProps {
  versionIdentifier: string
  isLibrary: boolean
  isNewLatest: boolean
}

export const useVersionStar = (props: UseVersionStarProps) => {
  const { versionIdentifier, ...modalProps } = props
  const { showModal } = useModalContext()
  const { showToast } = useToast()

  const shouldSkipModal: boolean =
    JSON.parse(
      localStorage.getItem('user:preferences:skipStarModal') || 'false'
    ) ?? false

  const [versionKindUpdate] = useVersionUpdateKind({
    onCompleted: () => {
      showToast('The Update has been starred')
    },
    onError: message => showToast(message, 'negative'),
  })

  if (shouldSkipModal) {
    return [
      () =>
        versionKindUpdate({
          versionIdentifier,
          kind: 'PUBLISHED',
        }),
    ]
  }

  return [
    () =>
      showModal(StarUpdateModal, {
        versionIdentifier: props.versionIdentifier,
        ...modalProps,
      }),
  ]
}
